<template lang="pug">
  #app.page(v-on:click="globalClick($event)")
    .page__decore-wr
      img.page__decore.page__decore--spot1(src="~@/assets/img/spot1.png")
      img.page__decore.page__decore--spot2(src="~@/assets/img/spot2.png")
      img.page__decore.page__decore--spot3(src="~@/assets/img/spot3.png")
      img.page__decore.page__decore--spot4(src="~@/assets/img/spot4.png")
      img.page__decore.page__decore--spot5(src="~@/assets/img/spot5.png")
      img.page__decore.page__decore--spot6(src="~@/assets/img/spot6.png")
      img.page__decore.page__decore--spot7(src="~@/assets/img/spot7.png")
      img.page__decore.page__decore--branch1(src="~@/assets/img/branch1.png")
      img.page__decore.page__decore--branch2(src="~@/assets/img/branch2.png")
      img.page__decore.page__decore--branch3(src="~@/assets/img/branch3.png")
      img.page__decore.page__decore--branch4(src="~@/assets/img/branch4.png")
      img.page__decore.page__decore--branch5(src="~@/assets/img/branch5.png")
      img.page__decore.page__decore--branch6(src="~@/assets/img/branch6.png")
      img.page__decore.page__decore--branch7(src="~@/assets/img/branch7.png")
      img.page__decore.page__decore--branch8(src="~@/assets/img/branch8.png")
      img.page__decore.page__decore--branch9(src="~@/assets/img/branch9.png")
      img.page__decore.page__decore--branch10(src="~@/assets/img/branch10.png")
      img.page__decore.page__decore--branch11(src="~@/assets/img/branch11.png")
      .page__decore.page__decore--line1
      .page__decore.page__decore--line2
      .page__decore.page__decore--line3
      .page__decore.page__decore--line4

    Header

    router-view

    Footer

    PopupProduct

    .page__preloader
      Preloader

    Burger
    MobileMenu
</template>

<script>
  import EventBus from '@/eventBus';

  import Header from '@/components/common/header/Header';
  import Footer from '@/components/common/footer/Footer';
  import PopupProduct from '@/components/common/popups/popupProduct/popupProduct';
  import Preloader from '@/components/common/preloader/Preloader.vue';
  import Burger from '@/components/common/burger/burger.vue';
  import MobileMenu from '@/components/common/mobileMenu/mobileMenu.vue';

  export default {
    components: {
      MobileMenu,
      Header,
      Footer,
      PopupProduct,
      Preloader,
      Burger
    },

    created() {
      this.$nextTick(() => {
        this.initParallaxCustom();
      });
    },

    methods: {
      initParallaxCustom() {
        $(document).on('mousemove', event => {
          let offsetX = event.clientX,
              offsetY = event.clientY;

          $('.page__decore--branch1').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`);
          $('.page__decore--branch2').css('transform', `translate(${offsetX * -0.01}px, ${offsetY * 0.01}px)`);
          $('.page__decore--branch3').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`);
          $('.page__decore--branch4').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * 0.015}px)`);
          $('.page__decore--branch5').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`);
          $('.page__decore--branch6').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * -0.01}px)`);
          $('.page__decore--branch7').css('transform', `translate(${offsetX * -0.01}px, ${offsetY * 0.01}px)`);
          $('.page__decore--branch8').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`);
          $('.page__decore--branch9').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`);
          $('.page__decore--branch10').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * -0.01}px)`);
          $('.page__decore--branch11').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`);
        });
      },

      // Закрыть попап по клику вне его
      globalClick(e) {
        let str = $(e.target).attr('class') || '';

        // Mobile menu left
        if(str.indexOf('js-mobile-menu-left') < 0 && $('.' + str).parents('.js-mobile-menu-left').length === 0) {
          EventBus.$emit('closeMenuLeftEvent');
        }
      }
    }
  }
</script>
